import * as actions from '../actions'

var defaultState = null

export default function resourceDeletedMedia(state = defaultState, action) {
    switch (action.type) {
        case actions.RESOURCE_DELETE_MEDIA:
            var newState = state
            if (!action.error) {
                newState = defaultState
            }
            return newState
        case actions.RESOURCE_DELETE_MEDIA_CLEAN:
            return defaultState
        default:
            return state
    }
}
